<template>
<div class="bigdata-board">
    <div class="top">
        <div class="status"><span class="squar color-skyblue"></span>订单量</div>
        <div class="status"><span class="squar color-orange"></span>结算量</div>
        <div class="status"><span class="squar color-blue"></span>待执行量</div>
    </div>
    <el-row style="margin: 0 auto; width: 1300px; margin-bottom: 20px;">
        <el-col :span="11">
            <div id="main1" class="grid-content bg-purple-dark"></div>
        </el-col>
        <el-col :span="11" :offset="2">
            <div id="main2" class="grid-content bg-purple-dark"></div>
        </el-col>
    </el-row>
    <el-row style="margin: 0 auto; width: 1300px; margin-bottom: 20px;">
        <el-col :span="11">
            <div id="main3" class="grid-content bg-purple-dark"></div>
        </el-col>
        <el-col :span="11" :offset="2">
            <div id="main4" class="grid-content bg-purple-dark"></div>
        </el-col>
    </el-row>
    <el-row style="margin: 0 auto; width: 1300px; margin-bottom: 20px;">
        <el-col :span="11">
            <div id="main5" class="grid-content bg-purple-dark"></div>
        </el-col>
        <el-col :span="11" :offset="2">
            <div class="table-title">特殊订单情况</div>
            <el-table :data="tableData" height="190" border style="width: 100%;" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                <el-table-column align="center" prop="order_num" label="订单号" min-width="33%">
                </el-table-column>
                <el-table-column align="center" prop="custom_name" label="客户名称" min-width="33%">
                </el-table-column>
                <el-table-column align="center" prop="variety" label="品种" min-width="33%">
                </el-table-column>
                <el-table-column align="center" prop="overdue_cause" label="超期原因" min-width="33%">
                </el-table-column>
            </el-table>
            <div class="remark">备注：特殊订单包含生产厂无法正常提供的订</div>
        </el-col>
    </el-row>
</div>
</template>

<script>
export default {
    data() {
        return {
            option: {
                title: {
                    text: '',
                    x: 'center',
                    y: 'top'
                },
                // color: ['#00A4E1', '#FE5500', '#3E2EA2'],
                color: ['#00A4E1', '#FE5500', '#3E2EA2'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '0',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    splitLine:{show: false},
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        interval: 0,
                        // rotate: 40
                    },
                    data: []
                    // data: []
                }],
                yAxis: [{
                    type: 'value',
                    splitLine:{show: false},
                    
                    name: '/吨'
                }],
                series: [{
                        name: '订单量',
                        type: 'bar',
                        barGap: 0,
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                        // data: [320, 332, 301, 334]
                        data: []
                    },
                    {
                        name: '已发货',
                        type: 'bar',
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                        // data: [120, 132, 101, 134]
                        data: []
                    },
                    {
                        name: '待执行量',
                        type: 'bar',
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                        // data: [130, 142, 111, 144]
                        data: []
                    }
                ]
            },
            tableData: [
                {
                    date: '2016-05-02',
                    name: '王小虎',
                    zip: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    zip: '上海市普陀区金沙江路 1517 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    zip: '上海市普陀区金沙江路 1519 弄'
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    zip: '上海市普陀区金沙江路 1516 弄'
                }
            ]
        }
    },
    created() {
        this.$nextTick(() => {
            this.axios.get('https://xarh.sprucesmart.com/api/v2/production_marketing')
            .then(res => {
                res.data.pl_data.forEach((item, index) => {
                    let tempOption = JSON.parse(JSON.stringify(this.option));
                    tempOption.title.text = res.data.pl_data[index].pl_name + '订单量';
                    // tempOption.xAxis[0].data = res.data.pl_data[index].factory_list;
                    tempOption.xAxis[0].data = ['兰州厂', '北京厂', '无锡脂', '克拉玛依厂', '大连厂', '华东厂', '委外生产厂', '成都厂']
                    tempOption.series[0].data = res.data.pl_data[index].pl_order;
                    tempOption.series[1].data = res.data.pl_data[index].pl_shipped;
                    tempOption.series[2].data = res.data.pl_data[index].pl_data_executed;
                    var myChart = this.$echarts.init(document.getElementById('main' + (index + 1)));
                    myChart.setOption(tempOption);
                });
                this.tableData = res.data.special_order_data
            })
        })
    },
    methods: {
        changeTableHeaderStyle({row, rowIndex}) {
            return "color: white; background-color: #3E2EA2;";
        },
        changeTableStyle ({row, column, rowIndex, columnIndex}) {
            if(columnIndex == 5) {
                if(row.status_num == -1) {
                    return 'color: #FF3333;'
                }
                else if(row.status_num == 0) {
                    return 'color: #29bd7f;'
                }
                else if(row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
    }
}
</script>

<style scoped>
.bigdata-board {
    position: relative;
    background-color: #FCFCFC;
    padding-top: 70px;
}
#main1,
#main2,
#main3,
#main4,
#main5,
#main6 {
    width: 600px;
    height: 250px;
    padding: 10px;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 13px #ccc;
}
#main1 {
    box-shadow: 0px 0px 30px #ccc;
}
#main6 {
    box-shadow: 0 0 0 ;
}
.table-title {
    color: #000;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
}
.remark {
    color: #000;
    text-align: center;
    font-size: 16px;
    margin-top: 8px;
}
.top {
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translate(-50%, 0);
    margin: 0 auto;
}
.status {
    display: inline-block;
    margin-right: 20px;
    height: 18px;
    line-height: 18px;
}
.squar {
    display: inline-block;
    width: 18px;
    height: 18px;
    position: relative;
    top: 3px;
    margin-right: 8px;
}
.color-skyblue {
    background-color: #00A4E1;
}
.color-orange {
    background-color: #FE5500;
}
.color-blue {
    background-color: #3E2EA2;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataBoard/bigDataBoard/ProductSale.vue